import { AxiosInstance } from "axios";
import { type ICore } from "./interfaces";

export function getCancellationReasonsBuilder(apiClient: AxiosInstance) {
  return async function getCancellationReasons(): Promise<
    ICore.CancellationReason[]
  > {
    const response = await apiClient.get(
      `/subscriptions/cancellation_reasons/`
    );
    return response.data;
  };
}
